function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 11C3 10.4477 3.44772 10 4 10H20C20.5523 10 21 10.4477 21 11V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V11ZM5 12V21H19V12H5Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.82428 2.45216C8.95767 1.50767 10.4617 1 12 1C13.5383 1 15.0423 1.50767 16.1757 2.45216C17.3144 3.40109 18 4.73143 18 6.16667V12H16V6.16667C16 5.39177 15.632 4.60248 14.8954 3.98861C14.1534 3.3703 13.1139 3 12 3C10.8861 3 9.84661 3.3703 9.10465 3.98861C8.368 4.60248 8 5.39177 8 6.16667V8.5H6V6.16667C6 4.73143 6.68556 3.40109 7.82428 2.45216Z",
  fill: "currentColor"
});

function SvgIconUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.bd6eaf6e.svg";
export { ForwardRef as ReactComponent };